import React from 'react';

// The left-hand panel on login/sign-up. Logged-out visitors to the domain
// land on /login, so this doubles as the one-glance pitch for the product.
const STEPS = [
  ['Scan', 'Swap QR codes before you leave the 18th green.'],
  ['Connect', 'They’re saved with the course and the day you met.'],
  ['Play again', 'See open tee times from the people you’ve played with.'],
];

function AuthPitch() {
  return (
    <aside className="auth-pitch">
      <span className="auth-pitch-logo">around</span>
      <h2 className="auth-pitch-title">Never lose a golf buddy.</h2>
      <p className="auth-pitch-lede">
        Got paired with strangers and had a great round? Keep them in your golf life.
      </p>
      <ol className="auth-pitch-steps">
        {STEPS.map(([title, text], i) => (
          <li key={title}>
            <span className="auth-pitch-num">{String(i + 1).padStart(2, '0')}</span>
            <span>
              <strong>{title}</strong>
              {text}
            </span>
          </li>
        ))}
      </ol>
    </aside>
  );
}

export default AuthPitch;
